import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge24 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='無記名式ゴルフ会員権とは' fontWeight={700} />
                <p>
                    個人会員は本人しかプレーできない記名式のみですが、法人会員には「無記名式」と「記名式」の2種類があり、無記名式であればその法人に所属する人であれば誰でもプレーが可能です。登録者の異動や退職のたびに名義書換をする必要がなく便利な仕組みですが、現在では発行しているゴルフ場が非常に限られています。
                    <br />
                    本記事では、無記名式ゴルフ会員権の仕組みや記名式との違い、メリット・デメリット、購入・売却時の注意点を詳しく解説します。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='無記名式が減った理由' fontWeight={700} />
                <p>
                    無記名式のゴルフ会員権は、1985年頃までは多く発行され、売買も活発に行われていました。しかし現在では新規発行されるケースはほとんどなく、既存の無記名式会員権も売買や譲渡による名義書換の際に記名式へ変更されることが一般的です。
                    <br />
                    無記名式が減った主な理由は、利用規約で禁止されている会員権の貸し借りを行う会員が現れたことにあります。会員権を所有する法人以外の第三者に貸し出すなどの不正利用によってゴルフ場側が被害を受けたため、多くのゴルフ場が無記名式の発行を廃止しました。
                    <br />
                    現在もなお無記名式会員権を発行しているゴルフ場は、神奈川カントリークラブや東京国際空港ゴルフ倶楽部など、ごく一部に限られます。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='無記名式と記名式の違い' fontWeight={700} />

                <Heading3 title='利用できる人の範囲' />
                <p>
                    無記名式は法人に属する人であれば誰でもプレーできますが、記名式は会員権にあらかじめ登録された特定の人物しかプレーできません。記名式には1名のみが利用できる1名記名式と、複数人が記名されているものがあります。記名式の種類やメリット・デメリットについては
                    <a href='/knowledge/50'>記名式会員権とは</a>
                    で詳しくご紹介しています。
                </p>

                <Heading3 title='価格' />
                <p>
                    無記名式は記名式に比べて購入料金がやや高めに設定されている点が特徴です。記名式の会員権代金は記名人数に比例する傾向があり、2名記名式であれば個人会員の2倍、1名のみであれば個人会員と同等の料金になることが一般的です。
                </p>

                <Heading3 title='名義書換の手続き' />
                <p>
                    無記名式は利用者の異動や退職があっても法人内であれば名義書換の手続きが不要です。一方、記名式は利用者を変更するたびに名義書換料が発生します。ただし同一法人内での名義書換料は、個人の名義書換料の半額程度になるケースが多くなっています。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='無記名式ゴルフ会員権のメリット・デメリット' fontWeight={700} />

                <Heading3 title='メリット：登録者が変わっても名義書換が不要' />
                <p>
                    無記名式の最大のメリットは、法人に属する人であれば誰でも利用できるため、接待や社内のゴルフ愛好者への割り当てなど、利用シーンに応じて柔軟に運用できる点です。登録者の異動や退職が多い企業にとっては、そのたびに名義書換の手続きや費用が発生しないことは大きな利点といえます。
                </p>

                <Heading3 title='デメリット：発行しているゴルフ場が少なく、購入料金も高め' />
                <p>
                    一方で、現在無記名式を発行しているゴルフ場はごく一部に限られるため、希望のエリアやゴルフ場で購入できるとは限りません。また前述のとおり、記名式に比べて購入料金が高めに設定されている点もデメリットです。
                    <br />
                    なお、法人でゴルフ会員権を持つこと自体のメリット・デメリット（経費計上や維持費など）については
                    <a href='/knowledge/14'>法人のゴルフ会員権とは？記名式と無記名式の違いについても解説</a>
                    で詳しくご紹介していますので、あわせてご確認ください。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='無記名式ゴルフ会員権を売買する際の注意点' fontWeight={700} />
                <p>
                    無記名式ゴルフ会員権を売却する場合、買い手側で記名式への変更を希望されることが多く、その際は追加の名義書換料が発生する可能性があります。売却前に、無記名式のまま譲渡できるのか、記名式への変更が必要なのかをゴルフ場に確認しておきましょう。
                    <br />
                    また、無記名式は発行数自体が少なく市場に出回る数も限られるため、相場が把握しづらい傾向があります。売却・購入いずれの場合も、無記名式の取引実績が豊富な会員権業者に相談することをおすすめします。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='まとめ' fontWeight={700} />
                <p>
                    無記名式ゴルフ会員権は、法人に属する人であれば誰でも利用できる利便性の高い会員権ですが、発行しているゴルフ場は年々減少しており、現在ではごく一部のゴルフ場でしか新規発行されていません。購入を検討する場合は対象ゴルフ場が限られること、売却する場合は記名式への変更が必要になる可能性があることを踏まえて、実績のある会員権業者に相談しながら進めることが大切です。
                    <br />
                    ご購入・ご売却の際にはゴルフ会員権の売買実績を有する住地ゴルフにまずはご相談ください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge24;
